import { assetUtils } from '@zen/common-utils';

/**
 * Display the price, shows a hint if price is less than a kalapa
 *
 * @param {string|number} asset
 * @param {Array} naming
 * @param {boolean} isMobile
 * @returns {string}
 */
export function displayName(asset, naming, isMobile = false) {
  return naming && naming[asset]
    ? naming[asset].shortName
    : assetUtils.truncateOrNameAsset(asset, isMobile ? 3 : 6);
}

/**
 * check if the asset name is coming from the naming server.
 * Format of the naming date DDMMYY
 * @param {string} assetName
 */
export function isRedeemableDayAsset(assetName) {
  const found = getRedeemableDayData(assetName);
  if (!found) return false;
  const day = found.substr(0, 2);
  const month = found.substr(2, 2);
  const year = found.substr(4, 2);
  return Date.UTC(`20${year}`, month - 1, day) < Date.now();
}

/**
 * get from the asset naming server is coming from the naming server.
 * @param {string} assetName
 */
export function getRedeemableEODTimestamp(assetName) {
  const found = getRedeemableDayData(assetName);
  if (!found) return false;
  const day = found.substr(0, 2);
  const month = found.substr(2, 2);
  const year = found.substr(4, 2);
  const hours = isDstObserved(new Date(`20${year}`, month - 1, day, 2)) ? '20' : '21';
  return Date.UTC(`20${year}`, month - 1, day, hours).toString();
}

/**
 *
 * @param {string} assetName
 */
export function getRedeemableEODTimestampHigh(assetName) {
  let found = getRedeemableDayHighData(assetName);
  if (!found) return '';
  const day = found.substr(1, 2);
  const month = found.substr(3, 2);
  const year = found.substr(5, 2);
  const hours = isDstObserved(new Date(`20${year}`, month - 1, day, 2)) ? '20' : '21';
  return Date.UTC(`20${year}`, month - 1, day, hours).toString();
}

/**
 * check if the asset has a unique date.
 * @param {string} assetName
 */
export function hasOnlyOneDate(assetName) {
  if (!assetName) return false;
  const firstRegex = /[0-9]{6}/g;
  return assetName.match(firstRegex).length === 1;
}

/**
 * get from the asset naming server is coming from the naming server.
 * Format of the naming date DDMMYY
 * @param {string} assetName
 */
export function getRedeemableDayData(assetName) {
  const firstRegex = /[0-9]{6}/;
  const found = firstRegex.exec(assetName);
  if (!found) return '';
  return found[0];
}

/**
 * get from the asset naming server is coming from the naming server.
 * Format of the naming date DDMMYY
 * @param {string} assetName
 */
export function getRedeemableDayHighData(assetName) {
  const firstRegex = /H[0-9]{6}/;
  const found = firstRegex.exec(assetName);
  if (!found) return '';
  return found[0];
}

/**
 * get from the asset naming server is coming from the naming server.
 * Format of the naming date DDMMYY
 * @param {string} assetName
 */
export function getRedeemablePriceData(assetName) {
  const firstRegex = /[0-9]*$/;
  const found = firstRegex.exec(assetName);
  if (!found[0]) return '';
  return found[0];
}

/**
 * get from the asset naming server is coming from the naming server.
 * @param {string} assetName
 */
export function getRedeemableTickerData(assetName) {
  const firstRegex = /^[A-Z./]*/;
  const found = firstRegex.exec(assetName);
  if (!found[0]) return '';
  return found[0];
}

/**
 * get from the asset naming server is coming from the naming server.
 * @param {string} assetName
 */
export function getRedeemablePositionData(assetName) {
  const firstRegex = /Bull|Bear/;
  const found = firstRegex.exec(assetName);
  if (!found[0]) return '';
  return found[0];
}

/**
 * Check if the daylight saving time is in effect
 * @param {Date} date,
 * @returns {boolean}
 **/

export function isDstObserved(date) {
  const jan = new Date(date.getFullYear(), 0, 1);
  const jul = new Date(date.getFullYear(), 6, 1);
  const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  return date.getTimezoneOffset() < stdTimezoneOffset;
}
